import React from "react";
import './InvestMenuElement.css';
import ChangeLink from "../../../../../Elements/ChangeLink/ChangeLink";
function InvestMenuElement(props) {
//console.log('InvestMenuElement',props.lang,props.ssilka);
    return (
    <div className={[props.inactive].join(' ')}><nobr>
        <ChangeLink lang={props.lang} to={props.ssilka} activeClassName="InvestMenuElementActiveLink"  style={{textDecoration: 'none'}}
              getProps={({ isPartiallyCurrent }) => {return isPartiallyCurrent ? { className: props.active } : null}}
        >{props.label}</ChangeLink>
    </nobr></div>
)}

export default InvestMenuElement